module.exports = __webpack_public_path__ + "assets/img/profile-attributes.89e8c7e5.svg";